import React, { createContext, useContext, useState } from 'react';

type StickyFooterButton = {
  label: string;
  style?: any;
  disabled?: boolean;
  onClick?: () => void;
};

type StickyFooterContextType = {
  buttonList: StickyFooterButton[] | null;
  setButtonList: (buttons: StickyFooterButton[] | null) => void;
  footerContent: React.ReactNode;
  setFooterContent: (content: React.ReactNode) => void;
};

const StickyFooterContext = createContext<StickyFooterContextType>({
  buttonList: null,
  setButtonList: () => {},
  footerContent: null,
  setFooterContent: () => {},
});

export const useStickyFooter = () => useContext(StickyFooterContext);

export const StickyFooterProvider = ({ children }: { children: React.ReactNode }) => {
  const [buttonList, setButtonList] = useState<StickyFooterButton[] | null>(null);
  const [footerContent, setFooterContent] = useState<React.ReactNode>(null);

  return (
    <StickyFooterContext.Provider value={{ buttonList, setButtonList, footerContent, setFooterContent }}>
      {children}
    </StickyFooterContext.Provider>
  );
};
